import { useState } from 'react';

const navItems = [
  { label: 'Accueil', href: '/' },
  { label: 'Services', href: '/#services' },
  { label: 'À Propos', href: '/#about' },
  { label: 'Tarifs', href: '/tarifs' },
  { label: 'Contact', href: '/#contact' }
];

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <header className="bg-gradient-to-br from-black to-emerald-900 shadow-sm sticky top-0 z-50">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center">
            <h1>
              <img 
                src="https://static.readdy.ai/image/1b5bf65cdb1167a86a15b5f9c79eaa66/706f2801b9b9f5e313c7f2344dd0bcdb.jpeg" 
                alt="GO BACK LOGISTIQUE" 
                className="h-12 w-auto"
              />
            </h1>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('services')} className="text-gray-200 hover:text-emerald-400 transition-colors cursor-pointer whitespace-nowrap">
              Services
            </button>
            <button onClick={() => scrollToSection('about')} className="text-gray-200 hover:text-emerald-400 transition-colors cursor-pointer whitespace-nowrap">
              À propos
            </button>
            <button onClick={() => scrollToSection('advantages')} className="text-gray-200 hover:text-emerald-400 transition-colors cursor-pointer whitespace-nowrap">
              Avantages
            </button>
            <button
              onClick={() => scrollToSection('localisation')}
              className="text-gray-200 hover:text-emerald-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              Localisation
            </button>
            <button onClick={() => scrollToSection('contact')} className="bg-emerald-600 text-white px-6 py-2.5 rounded-full hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap">
              Contact
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-white cursor-pointer"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-white/20">
            <div className="flex flex-col space-y-4">
              <button onClick={() => scrollToSection('services')} className="text-gray-200 hover:text-emerald-400 transition-colors text-left cursor-pointer whitespace-nowrap">
                Services
              </button>
              <button onClick={() => scrollToSection('about')} className="text-gray-200 hover:text-emerald-400 transition-colors text-left cursor-pointer whitespace-nowrap">
                À propos
              </button>
              <button onClick={() => scrollToSection('advantages')} className="text-gray-200 hover:text-emerald-400 transition-colors text-left cursor-pointer whitespace-nowrap">
                Avantages
              </button>
              <button onClick={() => scrollToSection('localisation')} className="text-gray-200 hover:text-emerald-400 transition-colors text-left cursor-pointer whitespace-nowrap">
                Localisation
              </button>
              <button onClick={() => scrollToSection('contact')} className="bg-emerald-600 text-white px-6 py-2.5 rounded-full hover:bg-emerald-700 transition-colors text-center cursor-pointer whitespace-nowrap">
                Contact
              </button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}